import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _TaxCodeScheme } from '../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const TaxCodeSchemeEditor = ({ idSelector, onChange, label }: Props) => {

    const taxCodeScheme = useDataBean(_TaxCodeScheme)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        taxCodeScheme.instance.getTaxCodeSchemeCatalog(null).then(
            (resp) => {
                let x = resp;
                if (resp.length>0) {
                    setValue(resp[0].DataBeanProperties.IDTaxCodeScheme)
                }
                setLista(x)
            }
        )
    }

    return (
        <>
            <label>{label ?? "Tipos de Códigos de Clasificación de Impuestos"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null} >...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDTaxCodeScheme} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}